import { Component } from '@angular/core';

import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-section-header-field',
    imports: [],
    template: `
        <div class="section-header">
            <h3>{{ field.label }}</h3>
            @if (field.helpText && !readonly) {
                <p class="section-description">{{ field.helpText }}</p>
            }
        </div>
    `,
    styles: [`
        .section-header {
            padding: 16px;
            margin-top: 16px;
        }

        .section-header h3 {
            margin: 0 0 4px 0;
            font-size: 18px;
            font-weight: 600;
        }

        .section-description {
            margin: 0;
            color: var(--ion-color-medium);
            font-size: 14px;
        }
    `]
})
export class SectionHeaderFieldComponent extends BaseFieldComponent {
    initialize(_value: any): void {
        // Section headers don't have values
    }

    serialize(): any {
        return null;
    }
}
